import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { MARCAS, MODELOS } from "@/lib/seo-config";
import { SITE_URL } from "@/lib/seo-jsonld";
import { Logo } from "@/components/Logo";

export const Route = createFileRoute("/blindados/")({
  beforeLoad: () => { throw redirect({ to: "/" }); },
  head: () => {
    const url = `${SITE_URL}/blindados/`;
    const title = "Carros blindados à venda no Brasil — Catálogo | Busca Blindados";
    const description =
      "Catálogo de carros blindados monitorados em revendas e marketplaces do Brasil. Por modelo, por marca, atualizado em tempo real.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "robots", content: "index,follow" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: BlindadosHub,
});

function BlindadosHub() {
  return (
    <div className="min-h-screen text-foreground">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-6">
        <Link to="/" className="text-foreground" aria-label="Busca Blindados">
          <Logo className="h-6 w-auto md:h-10" />
        </Link>
        <Link
          to="/alertas"
          className="chip rounded-full px-4 py-2 text-xs font-medium text-foreground/90 dark:hover:bg-white/10 hover:bg-black/10"
        >
          Meus alertas
        </Link>
      </nav>

      <main className="mx-auto max-w-7xl px-6 pb-32 pt-6">
        <header className="max-w-2xl">
          <h1 className="font-display text-3xl text-foreground sm:text-5xl">
            Catálogo de blindados<span className="text-primary">.</span>
          </h1>
          <p className="mt-4 text-sm text-muted-foreground sm:text-base">
            Páginas dedicadas aos modelos e marcas mais procurados. Cada página mostra ofertas reais
            de revendas e marketplaces que monitoramos em tempo real.
          </p>
        </header>

        <section className="mt-12">
          <h2 className="font-display text-xl text-foreground sm:text-2xl">Por modelo</h2>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
            {MODELOS.map((m) => (
              <li key={m.slug}>
                <Link
                  to="/blindados/modelo/$slug"
                  params={{ slug: m.slug }}
                  className="surface-card flex items-center justify-between rounded-2xl px-4 py-3 text-sm transition dark:hover:bg-white/[0.05] hover:bg-black/[0.05]"
                >
                  <span>{m.displayName}</span>
                  <span className="text-muted-foreground">→</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>

        <section className="mt-12">
          <h2 className="font-display text-xl text-foreground sm:text-2xl">Por marca</h2>
          <ul className="mt-4 flex flex-wrap gap-2">
            {MARCAS.map((b) => (
              <li key={b.slug}>
                <Link
                  to="/blindados/marca/$slug"
                  params={{ slug: b.slug }}
                  className="chip rounded-full px-4 py-2 text-sm dark:hover:bg-white/10 hover:bg-black/10"
                >
                  {b.displayName}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </main>
    </div>
  );
}
